import { useEffect, useState } from "react";
import ReactSelect from "react-select";

// componentes
import EstadoFactura from "./EstadoFactura";
import Procedencia from "../components/ProcedenciaFacturacion"
import Loader from "../components/Loader";

// conexiones a la API
//import { AddIngresos } from "../api/ingresos";
import {
  FacturacionCCF,
  FacturacionFe,
  FacturacionSujetoExcluido,
  FacturacionTicket, // Added
  FacturacionExportacion,
  listFacturacionesLazy,
  Firmador,
  presentacionHacienda,
  Anulacion,
  presentar_anulacion,
  EliminarDTE,
  NotaCredito,
  envioFactura
} from "../api/ventas";
import { facturasCliente } from "../api/facturar";
import {
  listTipo_documento022,
  listPais020,
  listRecintoFiscal027,
  listRegimen028
} from "../api/hacienda";
import { listProductosLazy } from "../api/productos";
import { listClienteReceptor } from "../api/clientesReceptor";
import { firmadorCliente } from "../api/clientes";

// utilidades
import { DataVentaFCF } from '../utils/validaciones';
import { formatDateReadable } from '../utils/fechas';
import { abrirDte } from "../utils/abrirDte";
import { montoALetras } from "../utils/montoALetras";
import { showAlertError, showAlertExito } from "../utils/alertHelper";

const Ventas = () => {
  const [loading, setLoading] = useState(true);
  const [ventas, setVentas] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [buscar, setBuscar] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [editMode, setEditMode] = useState(false);

  // Modal principal
  const [showModal, setShowModal] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [proveedorSeleccionado, setClientesSeleccionado] = useState(null);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const today = new Date().toISOString().split('T')[0];
  const [fechaFacturacion, setFechaFacturacion] = useState(today);
  const [numeroFactura, setNumeroFactura] = useState("");
  const [codigoFactura, setCodigoFactura] = useState("");
  const [tipoFactura, setTipoFactura] = useState(""); // Default vacío para que cargue de DB
  const [aplicarRetencion, setAplicarRetencion] = useState(true);

  // Modal de productos
  const [showProductoModal, setShowProductoModal] = useState(false);
  const [productos, setProductos] = useState([]);
  const [buscarProducto, setBuscarProducto] = useState("");
  const [pagePro, setPagePro] = useState(1);
  const [totalPagesPro, setTotalPagesPro] = useState(1);
  const [limitPro] = useState(10);
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const [form, setForm] = useState({});

  // Estados para exportacion
  const [paises, setPaises] = useState([]);
  const [recintosFiscales, setRecintosFiscales] = useState([]);
  const [regimenes, setRegimenes] = useState([]);
  const [tiposDocReceptor, setTiposDocReceptor] = useState([]);

  const [pais, setPais] = useState("");
  const [recintoFiscal, setRecintoFiscal] = useState("");
  const [regimen, setRegimen] = useState("");
  const [tipoDocReceptor, setTipoDocReceptor] = useState("");

  // Modal para anular factura
  const [showAnularModal, setShowAnularModal] = useState(false);
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
  const [motivoAnulacion, setMotivoAnulacion] = useState("");
  const [solicita, setSolicita] = useState("");
  const [tipoDocumentoAnulacion, setTipoDocumentoAnulacion] = useState("18");
  const [numeroDocumento, setNumeroDocumento] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [mhResponse, setMhResponse] = useState(null);

  // Modal de confirmación de eliminación
  const [showEliminarModal, setShowEliminarModal] = useState(false);
  const [ventaAEliminar, setVentaAEliminar] = useState(null);

  // Modal de Nota de Crédito
  const [showNCModal, setShowNCModal] = useState(false);
  const [ventaNC, setVentaNC] = useState(null);          // venta original
  const [itemsNC, setItemsNC] = useState([]);             // items editables
  const [observacionesNC, setObservacionesNC] = useState("");

  const [resumenVenta, setResumenVenta] = useState({ subtotal: 0, impuestos: 0, total: 0 });

  const recalcularResumen = () => {
    const items = productosSeleccionados.map((p) => {
      const cantidad = Number(p.cantidad) || 0;
      const precioBruto = Number(p.precio) || 0;

      // Si el producto tiene IVA (20), extraemos el precio neto
      const hasIva = (p.tributos || ["20"]).includes("20");
      const precioUni = hasIva ? precioBruto / 1.13 : precioBruto;

      const ventaGravada = round2(cantidad * precioUni);

      // calcular tributos
      const tributos = (p.tributos || ["20"]).map(code => calculateTributoValue(code, cantidad, precioUni));
      const totalTrib = tributos.reduce((a, b) => a + b, 0);

      return { ventaGravada, totalTrib };
    });

    const subtotal = round2(items.reduce((acc, it) => acc + it.ventaGravada, 0));
    const impuestos = round2(items.reduce((acc, it) => acc + it.totalTrib, 0));
    const total = round2(subtotal + impuestos);

    setResumenVenta({ subtotal, impuestos, total });
  };


  const abrirModalAnular = (venta) => {
    setFacturaSeleccionada(venta);
    setMotivoAnulacion("");
    setNumeroDocumento("");
    setSolicita("");
    setTipoDocumentoAnulacion("18");
    setShowAnularModal(true);
  };

  // funcion para anular factura
  const anularFactura = async () => {
    if (!motivoAnulacion.trim()) {
      alert("Debe ingresar un motivo de anulación");
      return;
    }

    if (!solicita.trim()) {
      alert("Debe ingresar el nombre de la persona que solicita la anulación");
      return;
    }

    if (!numeroDocumento.trim()) {
      alert("Debe ingresar el número de documento");
      return;
    }

    let dataAnulacion = {
      codGeneration: facturaSeleccionada.codGeneration,
      motivoAnulacion: motivoAnulacion,
      nombreSolicita: solicita,
      tipDocSolicita: tipoDocumentoAnulacion,
      numDocSolicita: quitarGuiones(numeroDocumento)
    };

    try {

      setSubmitting(true);
      await Anulacion(dataAnulacion);
      await firmadorCliente({ id_dte: facturaSeleccionada.id });
      // await presentacionHacienda({id_dte: facturaSeleccionada.id}, facturaSeleccionada.dteSerial);
      await presentar_anulacion({ id_dte: facturaSeleccionada.id }, facturaSeleccionada.dteSerial);

      setShowAnularModal(false);
      await fetchData(1);
    } catch (error) {
      console.error("Error anulando factura", error);
    } finally {
      setSubmitting(false);
    }
  };


  const formatearDocumento = (valor, tipo) => {
    // Solo números
    valor = valor.replace(/\D/g, "");

    if (tipo === "18") {
      // 8 dígitos + 1
      if (valor.length > 8) valor = valor.slice(0, 9);
      return valor.replace(/^(\d{8})(\d{0,1})/, "$1-$2");
    }

    if (tipo === "36") {
      // 4 - 6 - 3 - 1 => total 14 dígitos
      if (valor.length > 14) valor = valor.slice(0, 14);

      return valor
        .replace(/^(\d{4})(\d{0,6})(\d{0,3})(\d{0,1})/, (_, a, b, c, d) => {
          let res = a;
          if (b) res += "-" + b;
          if (c) res += "-" + c;
          if (d) res += "-" + d;
          return res;
        });
    }

    return valor;
  };


  // Función para quitar guiones de un texto
  const quitarGuiones = (texto) => {
    if (!texto) return "";
    return texto.replace(/[-—]/g, "");
  };


  // Ejecutar recalculo cada vez que cambien productosSeleccionados
  useEffect(() => {
    recalcularResumen();
    // eslint-disable-next-line
  }, [productosSeleccionados]);

  // Mapa básico de tributos y reglas de cálculo (ajusta si tu backend tiene valores distintos)
  const TAX_MAP = {
    "20": { rate: 0.13, desc: "Impuesto al Valor Agregado 13%" },
    "C3": { rate: 0, desc: "Impuesto al Valor Agregado (exportaciones) 0%" },
    "59": { rate: 0.05, desc: "Turismo: por alojamiento (5%)" },
    "71": { fixed: 7, desc: "Turismo: salida del país por vía aérea $7.00" },
    "D1": { perUnit: 0.20, desc: "FOVIAL ($0.20 Ctvs. por galón)" },
    "C8": { perUnit: 0.10, desc: "COTRANS ($0.10 Ctvs. por galón)" }
  };

  const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
  const fmt = (n) => (round2(Number(n) || 0)).toFixed(2); // devuelve string con 2 decimales

  // busca producto en el estado 'productos' por id
  const getProductById = (id) => productos.find(p => String(p.id) === String(id)) || null;

  // calcula el valor del tributo según código
  function calculateTributoValue(codigo, cantidad, precioUni) {
    const base = Number(cantidad) * Number(precioUni);
    const cfg = TAX_MAP[codigo];
    if (!cfg) return 0;
    if (cfg.rate !== undefined) return round2(base * cfg.rate);
    if (cfg.fixed !== undefined) return round2(cfg.fixed);
    if (cfg.perUnit !== undefined) return round2(cfg.perUnit * Number(cantidad));
    return 0;
  }

  // construye el array ItemsProducts tal como lo pediste
  function buildItemsProductsFromSelected() {
    return productosSeleccionados.map((p, idx) => {
      const prod = getProductById(p.value) || {};
      // determinar códigos de tributo (puede venir en el producto como prod.tributos)
      let tribCodes = [];
      if (prod.tributos && Array.isArray(prod.tributos) && prod.tributos.length > 0) {
        // soporta formatos: ["20"] o [{codigo:"20",...}]
        tribCodes = prod.tributos.map(t => (typeof t === "string" ? t : (t.codigo || t.code || ""))).filter(Boolean);
      } else if (p.tributos && Array.isArray(p.tributos) && p.tributos.length > 0) {
        tribCodes = p.tributos.map(t => (typeof t === "string" ? t : (t.codigo || t.code || ""))).filter(Boolean);
      } else {
        // por defecto: IVA (20) — ajusta si no quieres este comportamiento
        tribCodes = ["20"];
      }

      const cantidad = Number(p.cantidad) || 0;
      const precioBruto = Number(p.precio) || 0;

      // Si tiene IVA, el precioUni para el DTE debe ser el neto
      const hasIva = tribCodes.includes("20");
      const precioUni = hasIva ? round2(precioBruto / 1.13) : precioBruto;

      const ventaGravada = round2(cantidad * precioUni);

      // crear array de objetos de tributo con valor calculado (valor como string con 2 decimales)
      const tributos = tribCodes.map(code => {
        const valorNum = calculateTributoValue(code, cantidad, precioUni);
        return {
          codigo: code,
          descripcion: (TAX_MAP[code] && TAX_MAP[code].desc) ? TAX_MAP[code].desc : "",
          valor: fmt(valorNum) // string con 2 decimales (coincide con tu ejemplo)
        };
      });

      return {
        numItem: idx + 1,
        idProducto: p.value,
        tipoItem: prod.tipoItem ? String(prod.tipoItem) : "1",
        numeroDocumento: null,
        codTributo: tribCodes[0] || null,
        descripcion: prod.name || p.label || "",
        cantidad,
        uniMedida: prod.uniMedida ? String(prod.uniMedida) : (p.uniMedida ? String(p.uniMedida) : "36"),
        precioUni,
        montoDescu: 0,
        ventaNoSuj: 0,
        ventaExenta: 0,
        ventaGravada,
        tributos,
        psv: 0,
        noGravado: 0
      };
    });
  }

  // construye el JSON final que pediste
  function buildVentaJsonForBackend() {
    const items = buildItemsProductsFromSelected();

    // subtotal (suma ventaGravada)
    const subtotal = round2(items.reduce((acc, it) => acc + (Number(it.ventaGravada) || 0), 0));

    // agrupar tributos por código y sumar
    const tribMap = {};
    items.forEach(it => {
      it.tributos.forEach(t => {
        const codigo = String(t.codigo);
        const valorNum = Number(t.valor) || 0;
        if (tribMap[codigo]) tribMap[codigo].valor += valorNum;
        else tribMap[codigo] = { codigo, descripcion: t.descripcion || "", valor: valorNum };
      });
    });

    const totalTributosNum = round2(Object.values(tribMap).reduce((s, t) => s + (t.valor || 0), 0));
    const totalNum = round2(subtotal + totalTributosNum);

    // resolver tipo de documento/código a partir del select (tipoFactura guarda id del tipo en tu código)
    const tipoDocObj = tipoDocumento.find(td => {
      const doc = td.typeFact || td;
      return String(doc.id) === String(tipoFactura);
    });
    const typeFacts = tipoDocObj ? (tipoDocObj.codigo || String(tipoFactura)) : String(tipoFactura || "03");

    const idCliente = proveedorSeleccionado ? String(proveedorSeleccionado.value) : "";

    // hora: si quieres la hora exacta del sistema
    const hora = new Date().toTimeString().split(" ")[0]; // "HH:MM:SS"

    return {
      typeFacts: String(typeFacts),
      idCliente: Number(idCliente),
      fecha: fechaFacturacion || new Date().toISOString().slice(0, 10),
      hora: hora,
      ItemsProducts: items.map(it => ({
        numItem: it.numItem,
        idProducto: it.idProducto,
        tipoItem: it.tipoItem,
        numeroDocumento: it.numeroDocumento,
        codTributo: it.codTributo,
        descripcion: it.descripcion,
        cantidad: it.cantidad,
        uniMedida: it.uniMedida,
        precioUni: it.precioUni,
        montoDescu: it.montoDescu,
        ventaNoSuj: it.ventaNoSuj,
        ventaExenta: it.ventaExenta,
        ventaGravada: it.ventaGravada,
        tributos: it.tributos.map(t => ({ codigo: t.codigo, descripcion: t.descripcion, valor: t.valor })),
        psv: it.psv,
        noGravado: it.noGravado
      })),
      total: fmt(totalNum),
      tipoFacturacion: 1
    };
  }


  function buildVentaJsonFe() {
    const items = buildItemsProductsFromSelected(); // tu función que obtiene los items

    // Subtotal (suma de ventaGravada)
    const subtotalNum = items.reduce((acc, it) => acc + (Number(it.ventaGravada) || 0), 0);

    // Agrupar tributos por código y sumar
    const tribMap = {};
    items.forEach(it => {
      it.tributos.forEach(t => {
        const codigo = String(t.codigo);
        const valorNum = Number(t.valor) || 0;
        if (tribMap[codigo]) tribMap[codigo].valor += valorNum;
        else tribMap[codigo] = { codigo, descripcion: t.descripcion || "", valor: valorNum };
      });
    });

    // Total de tributos
    const totalTributosNum = Object.values(tribMap).reduce((s, t) => s + (t.valor || 0), 0);
    const totalTributos = round2(totalTributosNum);

    // Total final
    const totalNum = subtotalNum + totalTributosNum;
    const total = round2(totalNum);

    // Resolver tipo de documento/código a partir del select

    const idCliente = proveedorSeleccionado ? String(proveedorSeleccionado.value) : "";

    // Hora actual
    const hora = new Date().toTimeString().split(" ")[0]; // "HH:MM:SS"

    // Determinar el código real a enviar en el JSON, 88 para Ticket, 01 para Factura
    const finalTypeFacts = tipoFactura === "88" ? "88" : "01";

    return {
      typeFacts: String(finalTypeFacts),
      idCliente: Number(idCliente),
      fecha: fechaFacturacion || new Date().toISOString().slice(0, 10),
      hora: hora,
      ItemsProducts: items.map(it => ({
        numItem: it.numItem,
        idProducto: it.idProducto,
        tipoItem: it.tipoItem,
        numeroDocumento: it.numeroDocumento,
        codTributo: it.codTributo,
        descripcion: it.descripcion,
        cantidad: it.cantidad,
        uniMedida: it.uniMedida,
        precioUni: it.precioUni,
        montoDescu: round2(it.montoDescu || 0),
        ventaNoSuj: round2(it.ventaNoSuj || 0),
        ventaExenta: round2(it.ventaExenta || 0),
        ventaGravada: round2(it.ventaGravada || 0),
        tributos: it.tributos.map(t => ({
          codigo: t.codigo,
          descripcion: t.descripcion,
          valor: round2(t.valor || 0)
        })),
        psv: round2(it.psv || 0),
        noGravado: round2(it.noGravado || 0)
      })),
      impuestos: totalTributos,
      total: total,
      tipoFacturacion: 1
    };
  }

  function buildVentaJsonSujetoExcluido() {
    const items = productosSeleccionados.map((p, idx) => {
      const prod = getProductById(p.value) || {};
      const cantidad = Number(p.cantidad) || 0;
      const precioUni = Number(p.precio) || 0;
      const compra = round2(cantidad * precioUni);

      return {
        numItem: idx + 1,
        tipoItem: prod.tipoItem ? Number(prod.tipoItem) : 1, // 1: Bien, 2: Servicio
        cantidad,
        codigo: null,
        uniMedida: prod.uniMedida ? Number(prod.uniMedida) : 59,
        descripcion: prod.name || p.label || "",
        precioUni,
        montoDescu: 0,
        compra
      };
    });

    const totalCompra = round2(items.reduce((acc, it) => acc + it.compra, 0));

    // Renta Retenida: 10% sobre el total de compra si aplicarRetencion es true
    const reteRenta = aplicarRetencion ? round2(totalCompra * 0.10) : 0;
    const totalPagar = round2(totalCompra - reteRenta);

    const idCliente = proveedorSeleccionado ? String(proveedorSeleccionado.value) : "";
    const hora = new Date().toTimeString().split(" ")[0];
    const fechaEmision = fechaFacturacion || new Date().toISOString().slice(0, 10);

    return {
      typeFacts: "14",
      idSucursal: 3, // Ajustar según sea necesario
      idCliente: String(idCliente),
      fecEmi: fechaEmision,
      horEmi: hora,
      cuerpoDocumento: items,
      resumen: {
        totalCompra,
        descu: 0,
        totalDescu: 0,
        subTotal: totalCompra,
        ivaRete1: 0,
        reteRenta,
        totalPagar,
        totalLetras: montoALetras(totalPagar),
        condicionOperacion: 1,
        pagos: [
          {
            codigo: "01",
            montoPago: totalPagar,
            referencia: null,
            plazo: null,
            periodo: null
          }
        ],
        observaciones: `Factura Sujeto Excluido del ${fechaEmision}`
      },
      apendice: null
    };
  }

  function buildVentaJsonExportacion() {
    const cuerpoDocumento = productosSeleccionados.map((p, idx) => {
      const prod = getProductById(p.value) || {};
      const cantidad = Number(p.cantidad) || 0;
      const precioUni = Number(p.precio) || 0;
      const ventaGravada = round2(cantidad * precioUni);

      return {
        idProducto: p.value,
        numItem: idx + 1,
        cantidad,
        codigo: prod.sku || null,
        uniMedida: prod.uniMedida ? Number(prod.uniMedida) : 59,
        descripcion: prod.name || p.label || "",
        precioUni,
        montoDescu: 0,
        ventaGravada,
        tributos: ["C3"],
        noGravado: 0
      };
    });

    const totalGravada = round2(cuerpoDocumento.reduce((acc, it) => acc + (it.ventaGravada || 0), 0));
    const idCliente = proveedorSeleccionado ? String(proveedorSeleccionado.value) : "";
    const hora = new Date().toTimeString().split(" ")[0];
    const fechaEmision = fechaFacturacion || new Date().toISOString().slice(0, 10);

    return {
      typeFacts: "11",
      idSucursal: 3,
      idCliente: String(idCliente),
      fecEmi: fechaEmision,
      horEmi: hora,
      id_pais: pais,
      id_resinto: recintoFiscal,
      id_regimen: regimen,
      cuerpoDocumento,
      resumen: {
        totalGravada,
        descuento: 0,
        porcentajeDescuento: 0,
        totalDescu: 0,
        seguro: 0,
        flete: 0,
        montoTotalOperacion: totalGravada,
        totalNoGravado: 0,
        totalPagar: totalGravada,
        totalLetras: montoALetras(totalGravada),
        condicionOperacion: 1,
        pagos: [
          {
            codigo: "01",
            montoPago: totalGravada,
            referencia: null,
            plazo: null,
            periodo: null
          }
        ],
        codIncoterms: null,
        descIncoterms: null,
        numPagoElectronico: null,
        observaciones: null
      }
    };
  }

  const fetchData = async (p = 1) => {
    try {
      setEditMode(false);
      setLoading(true);
      const busqueda = encodeURIComponent(buscar.trim());
      const data = await listFacturacionesLazy(p, limit, busqueda);
      setVentas(data.data);
      setTotalPages(data.totalPages);
      setPage(data.currentPage);

      const doc = await facturasCliente();
      setTipoDocumento(doc.data);

    } catch (error) {
      console.error("Error al obtener los ingresos", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCatalogosExportacion = async () => {
    try {
      if (paises.length === 0) {
        const [resPais, resRecinto, resRegimen, resTipoDoc] = await Promise.all([
          listPais020(),
          listRecintoFiscal027(),
          listRegimen028(),
          listTipo_documento022()
        ]);
        setPaises(resPais?.data || []);
        setRecintosFiscales(resRecinto?.data || []);
        setRegimenes(resRegimen?.data || []);
        setTiposDocReceptor(resTipoDoc?.data || []);
      }
    } catch (error) {
      console.error("Error cargando catálogos de exportación", error);
    }
  };

  const fetchClientes = async () => {
    try {
      const data = await listClienteReceptor();
      // Filtrar clientes con estado diferente de 0
      const clientesActivos = (data.data || []).filter(p => String(p.estado) !== "0" && String(p.status) !== "0");
      setClientes(clientesActivos.map(p => ({
        value: p.id,
        label: p.nrc + " | " + p.nombre + " | " + p.nombreComercial,
        original: p // preservamos el objeto original para validaciones
      })));
    } catch (error) {
      console.error("Error al obtener clientes receptores", error);
    }
  };

  const fetchProductos = async (p = 1) => {
    try {
      // Usamos encodeURIComponent para manejar espacios y caracteres especiales.
      // Si está vacío, enviamos cadena vacía.
      const busqueda = encodeURIComponent(buscarProducto.trim());
      const data = await listProductosLazy(p, limitPro, busqueda);

      // Filtrar productos con estado diferente de 0
      const productosActivos = (data.data || []).filter(prod => String(prod.estado) !== "0" && String(prod.status) !== "0");

      setProductos(productosActivos);
      setTotalPagesPro(data.totalPages || 1);
      setPagePro(data.currentPage || 1);
    } catch (error) {
      console.error("Error al obtener productos", error);
    }
  };

  useEffect(() => {
    fetchData(page);
    // eslint-disable-next-line 
  }, [page, limit, buscar]);

  useEffect(() => {
    if (showProductoModal) {
      fetchProductos(pagePro);
    }
    // eslint-disable-next-line 
  }, [showProductoModal, pagePro, buscarProducto]);

  const handleAddProducto = (producto) => {
    const newProd = {
      value: producto.id,
      label: `${producto.name}`,
      cantidad: 1,
      precio: producto.price,
    };

    setProductosSeleccionados(prev => {
      const exists = prev.find(p => p.value === newProd.value);
      if (!exists) {
        return [...prev, newProd];
      }
      return prev;
    });
  };

  const handleChangeCantidad = (index, cantidad) => {
    const updated = [...productosSeleccionados];
    updated[index].cantidad = cantidad;
    setProductosSeleccionados(updated);
  };

  const handleChangePrecio = (index, precio) => {
    const updated = [...productosSeleccionados];
    updated[index].precio = precio;
    setProductosSeleccionados(updated);
  };

  const handleSelectChange = (value, name) => {
    if (value) {
      setTipoFactura(value.value);
      setForm((prev) => ({ ...prev, [name]: value.value }));
    } else {
      setTipoFactura(null);
      setForm((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const opcionesActivas = (tipoDocumento || [])
    .filter((c) => {
      const doc = c.typeFact || c;
      return ["01", "03", "14", "88", "11"].includes(String(doc.codigo));
    })
    .map((c) => {
      const doc = c.typeFact || c;
      return {
        value: doc.id ? doc.id.toString() : "",
        label: doc.codigo ? `${doc.codigo} | ${doc.name}` : "Documento desconocido",
      };
    });

  const opcionesTipoDocumento = opcionesActivas;

  const handleProcesarVenta = async () => {
    setSubmitting(true);
    try {
      const ingresoData = {
        codigo_factura: codigoFactura,
        numero_factura: numeroFactura,
        id_proveedor: proveedorSeleccionado ? proveedorSeleccionado.value : null,
        fecha_ingreso: fechaFacturacion,
        id_sucursal: 3,   // ajusta según tu lógica
        id_typeFacts: tipoFactura,
        ingresoDetalle: productosSeleccionados.map((p) => ({
          id_producto: p.value,
          cantidad: Number(p.cantidad) || 0,
        })),
      };

      // validando los datos de envio para proceder al ingreso
      if (DataVentaFCF(ingresoData)) {
        // --- Validaciones de Negocio ---
        const clienteFull = clientes.find(c => String(c.value) === String(ingresoData.id_proveedor))?.original;

        // resolvemos el tipo de documento para usar el código oficial en la comparación
        let codigoDoc = "";
        if (tipoFactura === "88") {
          codigoDoc = "88"; // Caso especial Ticket virtual
        } else {
          const selectedDocTypeObj = tipoDocumento.find(td => {
            const doc = td.typeFact || td;
            return String(doc.id) === String(tipoFactura);
          });
          const selectedDocType = selectedDocTypeObj?.typeFact || selectedDocTypeObj;
          codigoDoc = selectedDocType?.codigo;
        }

        if (clienteFull && codigoDoc !== "88") {
          // 1. Validación de CCF (03) solo para Jurídica
          if (codigoDoc === "03" && String(clienteFull.id_tipo_persona) !== "2") {
            showAlertError("Restricción de Cliente", "El Comprobante de Crédito Fiscal (03) solo puede ser emitido a Personas Jurídicas.");
            setSubmitting(false);
            return;
          }

          // 2. Validación de Perfil Completo
          const camposFaltantes = [];
          if (!clienteFull.id_departamento) camposFaltantes.push("Departamento");
          if (!clienteFull.id_municipio) camposFaltantes.push("Municipio");
          if (!clienteFull.direccionComplemento) camposFaltantes.push("Dirección");
          if (!clienteFull.id_actividad_economica) camposFaltantes.push("Actividad Económica");

          if (camposFaltantes.length > 0) {
            showAlertError(
              "Perfil Incompleto",
              `El cliente debe tener asignado: ${camposFaltantes.join(", ")}. Por favor, actualice los datos del cliente antes de continuar.`
            );
            setSubmitting(false);
            return;
          }
        }
        // --- Generar el JSON de venta (el que quieres) ---
        let dataDTE;
        try {
          //agregando los datos de la venta 
          if (codigoDoc === "03") {
            dataDTE = await FacturacionCCF(buildVentaJsonForBackend());
          } else if (codigoDoc === "01") {
            dataDTE = await FacturacionFe(buildVentaJsonFe());
          } else if (codigoDoc === "14") {
            dataDTE = await FacturacionSujetoExcluido(buildVentaJsonSujetoExcluido());
          } else if (codigoDoc === "88") {
            dataDTE = await FacturacionTicket(buildVentaJsonFe());
          } else if (codigoDoc === "11") {
            dataDTE = await FacturacionExportacion(buildVentaJsonExportacion());
          }

          if (dataDTE?.status === 0 || dataDTE?.estado === 0) {
            showAlertError("Error", dataDTE.msg || "No se pudo procesar el ticket");
            setSubmitting(false);
            return;
          }


          setShowModal(false);
          setProductosSeleccionados([]);
        } catch (error) {
          showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
        }
        await fetchData(1);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  //funcion para enviar DTE a hacienda
  const PresentarDTE = async (id_dte, dteSerial) => {
    try {
      let firmadorDatos = await Firmador({ id_dte }, dteSerial);
      if (firmadorDatos) {
        const data = await presentacionHacienda({ id_dte });
        if (data && data.estado === 2 && data.detalle) {
          setMhResponse(data.detalle);
          setShowErrorModal(true);
        }
      }
    } catch (error) {
      console.error("Error presentando DTE", error);
    }
    await fetchData(1);
  };

  const abrirModalEliminar = (venta) => {
    setVentaAEliminar(venta);
    setShowEliminarModal(true);
  };

  const handleEliminarDTE = async () => {
    if (!ventaAEliminar) return;
    try {
      setSubmitting(true);
      await EliminarDTE({ codGeneration: ventaAEliminar.codGeneration });
      setShowEliminarModal(false);
      setVentaAEliminar(null);
      await fetchData(1);
    } catch (error) {
      console.error("Error eliminando DTE", error);
    } finally {
      setSubmitting(false);
    }
  };

  // ── Nota de Crédito ──────────────────────────────────────────────────
  const abrirModalNC = (venta) => {
    const jsonDte = typeof venta.jsonDte === "string" ? JSON.parse(venta.jsonDte) : venta.jsonDte;
    const cuerpo = jsonDte?.cuerpoDocumento || [];
    // Mapeamos los items originales para edición (guardamos max original)
    const items = cuerpo.map((it) => ({
      ...it,
      cantidadEdit: it.cantidad,
      precioUniEdit: it.precioUni,
      maxCantidad: it.cantidad,
      maxPrecio: it.precioUni,
    }));
    setVentaNC({ ...venta, jsonDte });
    setItemsNC(items);
    setObservacionesNC(jsonDte?.extension?.observaciones || "");
    setShowNCModal(true);
  };

  const handleNotaCredito = async () => {
    if (!ventaNC) return;
    const jsonDte = ventaNC.jsonDte;
    try {
      setSubmitting(true);

      const tipoDocumentoOriginal = jsonDte.identificacion.tipoDte;

      const ItemsProducts = itemsNC.map((it, idx) => {
        let tributosArmados = it.tributos
          ? it.tributos.map((t) =>
            typeof t === "string" ? { codigo: t, descripcion: "", valor: 0 } : t
          )
          : [{ codigo: "20", descripcion: "IVA 13%", valor: 0 }];

        // Si es Factura de Consumidor Final (01), quitamos el IVA (20) para evitar duplicado
        if (tipoDocumentoOriginal === "01") {
          tributosArmados = tributosArmados.filter((t) => t.codigo !== "20");
        }

        return {
          numItem: idx + 1,
          descripcion: it.descripcion,
          cantidad: Number(it.cantidadEdit) || 0,
          uniMedida: String(it.uniMedida),
          precioUni: Number(it.precioUniEdit) || 0,
          montoDescu: it.montoDescu || 0,
          tributos: tributosArmados,
          codigo: it.codigo || null,
          numeroDocumento: it.numeroDocumento || null,
        };
      });

      const subtotalItems = round2(
        ItemsProducts.reduce((acc, it) => acc + it.cantidad * it.precioUni, 0)
      );

      const payload = {
        typeFacts: "05",
        retencion1: false,
        ItemsProducts,
        precioUni: subtotalItems,
        documentosRelacionados: [
          {
            fechaEmision: jsonDte.identificacion.fecEmi,
            numeroDocumento: jsonDte.identificacion.codigoGeneracion,
            tipoDocumento: jsonDte.identificacion.tipoDte,
            tipoGeneracion: 1,
          },
        ],
        observaciones: observacionesNC || null,
        tipoFacturacion: 0,
      };

      const res = await NotaCredito(payload);
      if (res) {
        setShowNCModal(false);
        await fetchData(1);
      }
    } catch (error) {
      console.error("Error generando nota de crédito", error);
    } finally {
      setSubmitting(false);
    }
  };


  const handleEnvioFactura = async (codGeneration) => {
    try {
      setSubmitting(true);
      const res = await envioFactura({ codGeneration });
      if (res) {
        showAlertExito("¡Éxito!", "Factura enviada por correo exitosamente");
      }
    } catch (error) {
      console.error("Error enviando factura por correo", error);
    } finally {
      setSubmitting(false);
    }
  };


  //funcion para firmar DTE
  /*
  const FirmarDTE = async (id_dte) => {
    await Firmador({ id_dte: id_dte });
    await fetchData(1);
  };
*/

  const abrirTicket = (codGeneration) => {
    const url = `${process.env.REACT_APP_VISTA_TICKET}?codGeneration=${codGeneration}`;
    window.open(url, "_blank");
  };


  // Utilidad para obtener el rango de páginas a mostrar en la paginación (máximo 5)
  const getPaginationPages = (current, total, max = 5) => {
    let start = Math.max(1, current - Math.floor(max / 2));
    let end = start + max - 1;
    if (end > total) {
      end = total;
      start = Math.max(1, end - max + 1);
    }
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };


  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Encabezado */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4">
        <div>
          <h2 className="text-2xl font-bold text-slate-800">Gestión de Ventas</h2>
          <p className="text-sm text-slate-500 mt-1">Administre las facturas y comprobantes generados</p>
        </div>
        <button
          onClick={() => {
            fetchClientes();
            fetchCatalogosExportacion();
            setFechaFacturacion(today);
            setAplicarRetencion(true);
            setShowModal(true);
          }}
          className="bg-indigo-600 text-white px-5 py-2.5 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm shadow-indigo-200 font-medium flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Agregar Venta
        </button>
      </div>

      {/* Filtros */}
      <div className="flex flex-wrap items-center gap-4 mb-6 bg-white p-4 rounded-xl shadow-sm border border-slate-200">
        <div className="relative flex-grow max-w-md">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Buscar venta por cliente o documento..."
            value={buscar}
            onChange={(e) => setBuscar(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors bg-slate-50 focus:bg-white"
          />
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500 font-medium">Mostrar:</span>
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            className="border border-slate-300 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
          >
            {[10, 15, 25, 50, 100, 1000].map(num => (
              <option key={num} value={num}>
                {num} registros
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Tabla de ingresos - Visible solo en desktop */}
      <div className="hidden md:block bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden relative">
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex justify-center items-center z-10">
            <Loader />
          </div>
        )}
        <div className="overflow-x-auto custom-scrollbar">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200">
              <tr>
                <th className="px-4 py-3 font-semibold">Fecha</th>
                <th className="px-4 py-3 font-semibold">Cliente</th>
                <th className="px-4 py-3 font-semibold">Tipo de factura</th>
                <th className="px-4 py-3 font-semibold">Total Venta</th>
                <th className="px-4 py-3 font-semibold">Sucursal</th>
                <th className="px-4 py-3 font-semibold">Codigo Generacion</th>
                <th className="px-4 py-3 font-semibold">Numero de Control</th>
                <th className="px-4 py-3 font-semibold">Sello de Recepción</th>
                <th className="px-4 py-3 font-semibold">Procedencia</th>
                <th className="px-4 py-3 font-semibold text-center">Estado</th>
                <th className="px-2 py-3 font-semibold text-center sticky right-0 bg-slate-100 border-l border-slate-200 z-10 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.05)] w-40">Opciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {ventas.map((venta) => (
                <tr
                  key={venta.id}
                  className="hover:bg-indigo-50/50 transition-colors group"
                >
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{formatDateReadable(venta.createdAt)}</td>
                  <td className="px-4 py-3 text-slate-700 font-medium whitespace-nowrap">{venta.clienteReceptor}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                    {venta.TipoDocumento?.codigo} <br /> {venta.TipoDocumento?.name}
                  </td>
                  <td className="px-4 py-3 text-emerald-600 font-semibold whitespace-nowrap">${Number(venta.totalPagar).toFixed(2)}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                    {venta.Sucursale?.codigo_sucursal} <br /> {venta.Sucursale?.nombre}
                  </td>
                  <td className="px-4 py-3 text-slate-500 text-xs">{venta.codGeneration}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{venta.dteSerial}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap text-xs">{venta.selloRecibido}</td>
                  <td className="px-4 py-3 text-indigo-600 font-medium whitespace-nowrap">{Procedencia(Number(venta.tipoFacturacion))}</td>
                  <td className="px-4 py-3 text-center">
                    <EstadoFactura status={venta.status} />
                  </td>
                  <td className="px-2 py-3 sticky right-0 bg-slate-100 group-hover:bg-slate-200 border-l border-slate-200 z-0 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.03)] transition-colors">
                    <div className="flex flex-wrap items-center justify-center gap-1.5">
                      {["1", null, undefined].includes(venta?.status) && (
                        <button className="bg-white border border-slate-200 text-slate-600 px-3 py-1.5 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium">
                          Editar
                        </button>
                      )}
                      {String(venta.status) !== "7" && (
                        <button
                          onClick={() => {
                            if (venta.TipoDocumento?.codigo === "88") {
                              abrirTicket(venta.codGeneration);
                            } else {
                              abrirDte(venta.codGeneration);
                            }
                          }}
                          className="bg-indigo-50 text-indigo-700 border border-indigo-100 px-3 py-1.5 rounded-lg hover:bg-indigo-100 transition-colors text-xs font-medium"
                        >
                          Imprimir
                        </button>
                      )}

                      {String(venta.status) === "7" && (
                        <>
                          <button
                            onClick={() => {
                              if (venta.TipoDocumento?.codigo === "88") {
                                abrirTicket(venta.codGeneration);
                              } else {
                                abrirDte(venta.codGeneration);
                              }
                            }}
                            className="bg-indigo-50 text-indigo-700 border border-indigo-100 px-3 py-1.5 rounded-lg hover:bg-indigo-100 transition-colors text-xs font-medium"
                          >
                            Imprimir
                          </button>

                          <button
                            onClick={() => {
                              const detail = typeof venta.mhResponse === 'string' ? JSON.parse(venta.mhResponse) : venta.mhResponse;
                              setMhResponse(detail);
                              setShowErrorModal(true);
                            }}
                            className="bg-amber-50 text-amber-700 border border-amber-100 px-3 py-1.5 rounded-lg hover:bg-amber-100 transition-colors text-xs font-medium"
                          >
                            Ver Error
                          </button>
                          <button
                            onClick={() => abrirModalEliminar(venta)}
                            className="bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                          >
                            Eliminar
                          </button>
                        </>
                      )}

                      {["1"].includes(String(venta.status)) && (
                        <>
                          <button
                            onClick={() => PresentarDTE(venta.id, venta.dteSerial)}
                            className="bg-yellow-50 text-yellow-700 border border-yellow-100 px-3 py-1.5 rounded-lg hover:bg-yellow-100 transition-colors text-xs font-medium">
                            Presentar DTE
                          </button>

                          <button
                            onClick={() => abrirModalEliminar(venta)}
                            className="bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                          >
                            Eliminar
                          </button>
                        </>
                      )}

                      {["3"].includes(String(venta.status)) && venta.TipoDocumento?.codigo !== "88" && (
                        <>
                          <button
                            onClick={() => abrirModalAnular(venta)}
                            className="bg-red-50 text-red-600 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                          >
                            Anular
                          </button>
                          <button
                            onClick={() => abrirModalNC(venta)}
                            className="bg-purple-50 text-purple-700 border border-purple-100 px-3 py-1.5 rounded-lg hover:bg-purple-100 transition-colors text-xs font-medium"
                          >
                            Nota Crédito
                          </button>
                          <button
                            onClick={() => handleEnvioFactura(venta.codGeneration)}
                            className="bg-emerald-50 text-emerald-700 border border-emerald-100 px-3 py-1.5 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium"
                          >
                             Enviar correo
                          </button>
                        </>
                      )}

                      {["2"].includes(String(venta.status)) && (
                        <>
                          <button
                            onClick={() => PresentarDTE(venta.id, venta.dteSerial)}
                            className="bg-yellow-50 text-yellow-700 border border-yellow-100 px-3 py-1.5 rounded-lg hover:bg-yellow-100 transition-colors text-xs font-medium">
                            Presentar Dte
                          </button>

                          <button
                            onClick={() => abrirModalEliminar(venta)}
                            className="bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                          >
                            Eliminar
                          </button>
                        </>

                      )}

                      {["8"].includes(String(venta.status)) && (
                        <button
                          className="bg-orange-50 text-orange-700 border border-orange-100 px-3 py-1.5 rounded-lg hover:bg-orange-100 transition-colors text-xs font-medium">
                          Nota de Credito Emitida
                        </button>
                      )}

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Vista de Cards - Visible solo en móvil */}
      <div className="md:hidden space-y-4 relative min-h-[200px]">
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex justify-center items-center z-10 rounded-xl">
            <Loader />
          </div>
        )}

        {ventas.length === 0 && !loading && (
          <div className="bg-white p-8 rounded-xl border border-slate-200 text-center">
            <p className="text-slate-500">No se encontraron ventas</p>
          </div>
        )}

        {ventas.map((venta) => (
          <div key={venta.id} className="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 space-y-4">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-xs font-semibold text-indigo-600 uppercase tracking-wider">{formatDateReadable(venta.createdAt)}</p>
                <h4 className="font-bold text-slate-800 mt-1">{venta.clienteReceptor}</h4>
                <p className="text-xs text-slate-500 mt-1">
                  {venta.TipoDocumento?.codigo} | {venta.dteSerial || 'Sin serial'}
                </p>
              </div>
              <EstadoFactura status={venta.status} />
            </div>

            <div className="grid grid-cols-2 gap-4 py-3 border-y border-slate-50">
              <div>
                <p className="text-[10px] text-slate-400 uppercase font-bold tracking-tight">Total</p>
                <p className="text-lg font-bold text-emerald-600">${Number(venta.totalPagar).toFixed(2)}</p>
              </div>
              <div className="text-right">
                <p className="text-[10px] text-slate-400 uppercase font-bold tracking-tight">Sucursal</p>
                <p className="text-sm font-medium text-slate-700">{venta.Sucursale?.nombre || 'Central'}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 pt-1">
              {["1", null, undefined].includes(venta?.status) && (
                <button className="flex-grow bg-slate-50 text-slate-600 px-3 py-2 rounded-xl border border-slate-200 text-xs font-bold hover:bg-slate-100 transition-colors">
                  Editar
                </button>
              )}

              {String(venta.status) !== "7" && (
                <button
                  onClick={() => {
                    if (venta.TipoDocumento?.codigo === "88") {
                      abrirTicket(venta.codGeneration);
                    } else {
                      abrirDte(venta.codGeneration);
                    }
                  }}
                  className="flex-grow bg-indigo-50 text-indigo-700 px-3 py-2 rounded-xl border border-indigo-100 text-xs font-bold hover:bg-indigo-100 transition-colors"
                >
                  Imprimir
                </button>
              )}

              {String(venta.status) === "7" && (
                <>
                  <button
                    onClick={() => {
                      if (venta.TipoDocumento?.codigo === "88") {
                        abrirTicket(venta.codGeneration);
                      } else {
                        abrirDte(venta.codGeneration);
                      }
                    }}
                    className="bg-indigo-50 text-indigo-700 border border-indigo-100 px-3 py-1.5 rounded-lg hover:bg-indigo-100 transition-colors text-xs font-medium"
                  >
                    Imprimir
                  </button>
                  <button
                    onClick={() => {
                      const detail = typeof venta.mhResponse === 'string' ? JSON.parse(venta.mhResponse) : venta.mhResponse;
                      setMhResponse(detail);
                      setShowErrorModal(true);
                    }}
                    className="flex-grow bg-amber-50 text-amber-700 px-3 py-2 rounded-xl border border-amber-100 text-xs font-bold"
                  >
                    Ver Error
                  </button>
                  <button
                    onClick={() => abrirModalEliminar(venta)}
                    className="flex-grow bg-red-50 text-red-700 px-3 py-2 rounded-xl border border-red-100 text-xs font-bold"
                  >
                    Eliminar
                  </button>
                </>
              )}

              {["1"].includes(String(venta.status)) && (
                <>
                  <button
                    onClick={() => PresentarDTE(venta.id, venta.dteSerial)}
                    className="flex-grow bg-blue-50 text-blue-700 px-3 py-2 rounded-xl border border-blue-100 text-xs font-bold">
                    Presentar Dte
                  </button>

                  <button
                    onClick={() => abrirModalEliminar(venta)}
                    className="flex-grow bg-red-50 text-red-700 px-3 py-2 rounded-xl border border-red-100 text-xs font-bold"
                  >
                    Eliminar
                  </button>
                </>
              )}

              {["3"].includes(String(venta.status)) && venta.TipoDocumento?.codigo !== "88" && (
                <>
                  <button
                    onClick={() => abrirModalAnular(venta)}
                    className="flex-grow bg-red-50 text-red-600 px-3 py-2 rounded-xl border border-red-100 text-xs font-bold"
                  >
                    Anular
                  </button>
                  <button
                    onClick={() => abrirModalNC(venta)}
                    className="flex-grow bg-purple-50 text-purple-700 px-3 py-2 rounded-xl border border-purple-100 text-xs font-bold"
                  >
                    Nota Crédito
                  </button>
                  <button
                    onClick={() => handleEnvioFactura(venta.codGeneration)}
                    className="flex-grow bg-emerald-50 text-emerald-700 px-3 py-2 rounded-xl border border-emerald-100 text-xs font-bold"
                  >
                    Enviar correo
                  </button>
                </>
              )}

              {["2"].includes(String(venta.status)) && (
                <button
                  onClick={() => PresentarDTE(venta.id, venta.dteSerial)}
                  className="flex-grow bg-amber-50 text-amber-700 px-3 py-2 rounded-xl border border-amber-100 text-xs font-bold">
                  Presentar
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Paginación ventas */}
      <div className="flex justify-between items-center mt-6 p-4">
        <p className="text-sm text-slate-500 w-full sm:w-auto text-center mb-4 sm:mb-0">
          Página <span className="font-medium">{page}</span> de <span className="font-medium">{totalPages}</span>
        </p>
        <div className="flex gap-1 bg-white p-1 rounded-lg border border-slate-200 w-full sm:w-auto justify-center overflow-x-auto">
          <button
            disabled={page === 1}
            onClick={() => fetchData(page - 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === 1
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            Anterior
          </button>

          {getPaginationPages(page, totalPages, 5)[0] > 1 && (
            <>
              <button
                onClick={() => fetchData(1)}
                className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === 1 ? "bg-indigo-50 text-indigo-600" : "text-slate-600 hover:bg-slate-100"
                  }`}
              >
                1
              </button>
              {getPaginationPages(page, totalPages, 5)[0] > 2 && (
                <span className="px-2 py-1.5 text-slate-400">...</span>
              )}
            </>
          )}

          {getPaginationPages(page, totalPages, 5).map((num) => (
            <button
              key={num}
              onClick={() => fetchData(num)}
              className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num ? "bg-indigo-50 text-indigo-600" : "text-slate-600 hover:bg-slate-100"
                }`}
            >
              {num}
            </button>
          ))}

          {getPaginationPages(page, totalPages, 5).slice(-1)[0] < totalPages && (
            <>
              {getPaginationPages(page, totalPages, 5).slice(-1)[0] < totalPages - 1 && (
                <span className="px-2 py-1.5 text-slate-400">...</span>
              )}
              <button
                onClick={() => fetchData(totalPages)}
                className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === totalPages ? "bg-indigo-50 text-indigo-600" : "text-slate-600 hover:bg-slate-100"
                  }`}
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            disabled={page === totalPages}
            onClick={() => fetchData(page + 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === totalPages
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            Siguiente
          </button>
        </div>
      </div>



      {/* Modal Principal */}
      {showModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-center z-50 p-0 md:p-6 overflow-hidden w-full">
          <div className="bg-white md:rounded-2xl shadow-xl w-full h-full md:h-auto md:max-w-6xl md:max-h-[90vh] flex flex-col my-0 md:my-8 animate-fade-in-up overflow-hidden">
            <div className="flex flex-col md:flex-row flex-grow md:overflow-hidden overflow-y-auto custom-scrollbar">
              {/* Sección izquierda: Detalles ingreso */}
              <div className="w-full md:w-5/12 p-5 sm:p-6 border-b md:border-b-0 md:border-r border-slate-100 flex flex-col md:bg-slate-50/50 md:overflow-y-auto custom-scrollbar">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800">Nueva Venta</h3>
                </div>

                <div className="grid grid-cols-2 gap-x-4 gap-y-5">
                  <div className="col-span-2 md:col-span-2">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Cliente</label>
                    <ReactSelect
                      options={clientes}
                      onChange={setClientesSeleccionado}
                      placeholder="Seleccionar cliente..."
                      className="react-select-container"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                          borderRadius: '0.8rem',
                          minHeight: '44px',
                          padding: '2px',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                          '&:hover': {
                            borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                          }
                        })
                      }}
                    />
                  </div>

                  <div className="col-span-2 md:col-span-2">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Tipo Documento</label>
                    <ReactSelect
                      options={opcionesTipoDocumento}
                      value={opcionesTipoDocumento.find((opt) => opt.value === form.tipoDocumento) || null}
                      onChange={(val) => handleSelectChange(val, "tipoDocumento")}
                      placeholder="Seleccione tipo..."
                      isSearchable
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                          borderRadius: '0.8rem',
                          minHeight: '44px',
                          padding: '2px',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                          '&:hover': {
                            borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                          }
                        })
                      }}
                    />
                  </div>

                  <div className="col-span-2 md:col-span-2">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Fecha Facturación</label>
                    <input
                      type="date"
                      value={fechaFacturacion}
                      min={today}
                      onChange={(e) => setFechaFacturacion(e.target.value)}
                      className="w-full border border-slate-300 rounded-xl px-4 py-2.5 focus:ring-4 focus:ring-indigo-100 focus:border-indigo-500 transition-all bg-white text-sm"
                    />
                  </div>

                  {(() => {
                    const selectedDocTypeObj = tipoFactura === "88"
                      ? null
                      : tipoDocumento.find(td => {
                        const doc = td.typeFact || td;
                        return String(doc.id) === String(tipoFactura);
                      });
                    const codigoSeleccionado = (selectedDocTypeObj?.typeFact || selectedDocTypeObj)?.codigo || tipoFactura;
                    const esSujetoExcluido = codigoSeleccionado === "14";
                    const esExportacion = codigoSeleccionado === "11";

                    return (
                      <>
                        {esSujetoExcluido && (
                          <div className="col-span-2 md:col-span-2 flex items-center mt-2 px-1">
                            <label className="flex items-center cursor-pointer relative">
                              <input
                                type="checkbox"
                                checked={aplicarRetencion}
                                onChange={(e) => setAplicarRetencion(e.target.checked)}
                                className="peer sr-only"
                              />
                              <div className="w-11 h-6 bg-slate-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-indigo-300 transition-all peer-checked:bg-indigo-600 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-white"></div>
                              <span className="ml-3 text-sm font-medium text-slate-700">Aplicar Retención (10%)</span>
                            </label>
                          </div>
                        )}

                        {esExportacion && (
                          <>
                            <div className="col-span-2 md:col-span-2">
                              <label className="block mb-2 text-sm font-semibold text-slate-700">País</label>
                              <ReactSelect
                                options={paises.map(p => ({ value: p.id, label: `${p.codigo} | ${p.name}` }))}
                                value={paises.find(p => p.id === pais) ? { value: pais, label: paises.find(p => p.id === pais).name } : null}
                                onChange={(val) => setPais(val ? val.value : "")}
                                placeholder="Seleccionar..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                                    borderRadius: '0.8rem',
                                    minHeight: '44px',
                                    padding: '2px',
                                    boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                                    '&:hover': {
                                      borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                                    }
                                  })
                                }}
                              />
                            </div>
                            <div className="col-span-2 md:col-span-2">
                              <label className="block mb-2 text-sm font-semibold text-slate-700">Recinto Fiscal</label>
                              <ReactSelect
                                options={recintosFiscales.map(r => ({ value: r.id, label: `${r.codigo} | ${r.name}` }))}
                                value={recintosFiscales.find(r => r.id === recintoFiscal) ? { value: recintoFiscal, label: recintosFiscales.find(r => r.id === recintoFiscal).name } : null}
                                onChange={(val) => setRecintoFiscal(val ? val.value : "")}
                                placeholder="Seleccionar..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                                    borderRadius: '0.8rem',
                                    minHeight: '44px',
                                    padding: '2px',
                                    boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                                    '&:hover': {
                                      borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                                    }
                                  })
                                }}
                              />
                            </div>
                            <div className="col-span-2 md:col-span-2">
                              <label className="block mb-2 text-sm font-semibold text-slate-700">Régimen</label>
                              <ReactSelect
                                options={regimenes.map(r => ({ value: r.id, label: `${r.codigo} | ${r.name}` }))}
                                value={regimenes.find(r => r.id === regimen) ? { value: regimen, label: regimenes.find(r => r.id === regimen).name } : null}
                                onChange={(val) => setRegimen(val ? val.value : "")}
                                placeholder="Seleccionar..."
                                className="react-select-container"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                                    borderRadius: '0.8rem',
                                    minHeight: '44px',
                                    padding: '2px',
                                    boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                                    '&:hover': {
                                      borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                                    }
                                  })
                                }}
                              />
                            </div>
                          </>
                        )}
                      </>
                    );
                  })()}

                  <div className="col-span-1 hidden">
                    <label className="block mb-1 text-[11px] uppercase tracking-wider font-bold text-slate-400">Cód. Gen.</label>
                    <input
                      type="text"
                      readOnly
                      value={codigoFactura}
                      className="w-full border border-slate-200 bg-slate-50 rounded-xl px-3 py-2 text-slate-500 cursor-not-allowed text-[11px] font-mono truncate"
                    />
                  </div>

                  <div className="col-span-1 hidden">
                    <label className="block mb-1 text-[11px] uppercase tracking-wider font-bold text-slate-400">No. Control</label>
                    <input
                      type="text"
                      readOnly
                      value={numeroFactura}
                      className="w-full border border-slate-200 bg-slate-50 rounded-xl px-3 py-2 text-slate-500 cursor-not-allowed text-[11px] font-mono truncate"
                    />
                  </div>
                </div>
              </div>

              {/* Sección derecha: Productos */}
              <div className="w-full md:w-7/12 p-5 sm:p-6 flex flex-col md:overflow-y-auto custom-scrollbar">
                <div className="flex justify-between items-center mb-6">
                  <h4 className="text-lg font-bold text-slate-800">Detalle de Productos</h4>
                  <button
                    className="bg-indigo-50 text-indigo-600 border border-indigo-100 font-medium px-4 py-2 rounded-lg hover:bg-indigo-100 transition-colors flex items-center gap-2"
                    onClick={() => setShowProductoModal(true)}
                  >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    Agregar Producto
                  </button>
                </div>

                <div className="flex-grow overflow-auto custom-scrollbar border border-slate-200 rounded-xl mb-6">
                  {productosSeleccionados.length > 0 ? (
                    <>
                      <div className="hidden md:block">
                        <table className="w-full text-sm text-left">
                          <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200 sticky top-0">
                            <tr>
                              <th className="px-4 py-3 font-semibold">Producto</th>
                              <th className="px-4 py-3 font-semibold w-24">Cantidad</th>
                              <th className="px-4 py-3 font-semibold w-40">Precio Unit.</th>
                              <th className="px-4 py-3 font-semibold w-40 text-right">Total</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100">
                            {productosSeleccionados.map((prod, i) => (
                              <tr key={prod.value} className="hover:bg-slate-50 transition-colors">
                                <td className="px-4 py-3 text-slate-700 font-medium">{prod.label}</td>
                                <td className="px-4 py-3">
                                  <input
                                    type="number"
                                    min="1"
                                    value={prod.cantidad}
                                    onChange={(e) => handleChangeCantidad(i, e.target.value)}
                                    className="w-20 border border-slate-300 rounded-lg px-2 py-1.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-center"
                                  />
                                </td>
                                <td className="px-4 py-3">
                                  <div className="relative">
                                    <span className="absolute left-2 top-1.5 text-slate-500">$</span>
                                    <input
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      value={prod.precio}
                                      onChange={(e) => handleChangePrecio(i, e.target.value)}
                                      className="w-full pl-6 pr-2 py-1.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                                    />
                                  </div>
                                </td>
                                <td className="px-4 py-3 text-right font-semibold text-slate-700">
                                  ${(prod.precio * prod.cantidad).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="md:hidden space-y-4 p-4 bg-slate-50/50">
                        {productosSeleccionados.map((prod, i) => (
                          <div key={prod.value} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm space-y-3">
                            <div className="flex justify-between items-start gap-2">
                              <h5 className="font-bold text-slate-800 text-sm leading-tight">{prod.label}</h5>
                              <button
                                onClick={() => {
                                  const newProds = [...productosSeleccionados];
                                  newProds.splice(i, 1);
                                  setProductosSeleccionados(newProds);
                                }}
                                className="text-slate-400 hover:text-red-500"
                              >
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <label className="block text-[10px] uppercase font-bold text-slate-400 mb-1">Cantidad</label>
                                <input
                                  type="number"
                                  min="1"
                                  value={prod.cantidad}
                                  onChange={(e) => handleChangeCantidad(i, e.target.value)}
                                  className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 transition-colors bg-white shadow-sm"
                                />
                              </div>
                              <div>
                                <label className="block text-[10px] uppercase font-bold text-slate-400 mb-1">Precio Unit.</label>
                                <div className="relative">
                                  <span className="absolute left-2 top-2 text-slate-400 text-xs">$</span>
                                  <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={prod.precio}
                                    onChange={(e) => handleChangePrecio(i, e.target.value)}
                                    className="w-full pl-5 pr-2 py-3 border border-slate-300 rounded-lg text-base focus:ring-2 focus:ring-indigo-500 transition-colors bg-white shadow-sm"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="pt-2 border-t border-slate-100 flex justify-between items-center">
                              <span className="text-[10px] uppercase font-bold text-slate-400">Total Item</span>
                              <span className="font-bold text-indigo-600">${(prod.precio * prod.cantidad).toFixed(2)}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="flex flex-col items-center justify-center h-48 text-slate-400">
                      <svg className="w-12 h-12 mb-2 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                      </svg>
                      <p>No hay productos en esta venta</p>
                      <p className="text-xs mt-1">Haga clic en "Agregar Producto" para comenzar</p>
                    </div>
                  )}
                </div>

                <div className="bg-slate-50 p-5 rounded-xl border border-slate-200 shrink-0">
                  {(() => {
                    // Detectar si el tipo seleccionado es Sujeto Excluido (código 14)
                    const selectedDocTypeObj = tipoFactura === "88"
                      ? null
                      : tipoDocumento.find(td => {
                        const doc = td.typeFact || td;
                        return String(doc.id) === String(tipoFactura);
                      });
                    const codigoSeleccionado = (selectedDocTypeObj?.typeFact || selectedDocTypeObj)?.codigo || tipoFactura;
                    const esSujetoExcluido = codigoSeleccionado === "14";
                    const esExportacion = codigoSeleccionado === "11";

                    if (esSujetoExcluido) {
                      const totalCompra = round2(
                        productosSeleccionados.reduce((acc, p) => acc + (Number(p.precio) || 0) * (Number(p.cantidad) || 0), 0)
                      );
                      const reteRenta = aplicarRetencion ? round2(totalCompra * 0.10) : 0;
                      const totalPagar = round2(totalCompra - reteRenta);
                      return (
                        <div className="space-y-3">
                          <div className="flex justify-between items-center text-slate-600">
                            <span className="font-medium">Total Compra</span>
                            <span>${totalCompra.toFixed(2)}</span>
                          </div>
                          {aplicarRetencion && (
                            <div className="flex justify-between items-center text-orange-600">
                              <span className="font-medium">Renta Retenida (10%)</span>
                              <span>-${reteRenta.toFixed(2)}</span>
                            </div>
                          )}
                          {!aplicarRetencion && (
                            <div className="flex justify-between items-center text-slate-400">
                              <span className="font-medium">Renta Retenida</span>
                              <span>$0.00</span>
                            </div>
                          )}
                          <div className="pt-3 border-t border-slate-200 flex justify-between items-center">
                            <span className="text-lg font-bold text-slate-800">Total a Pagar</span>
                            <span className="text-2xl font-bold text-emerald-600">${totalPagar.toFixed(2)}</span>
                          </div>
                        </div>
                      );
                    }

                    if (esExportacion) {
                      const totalGravada = round2(
                        productosSeleccionados.reduce((acc, p) => acc + (Number(p.precio) || 0) * (Number(p.cantidad) || 0), 0)
                      );
                      return (
                        <div className="space-y-3">
                          <div className="flex justify-between items-center text-slate-600">
                            <span className="font-medium">Total Operación</span>
                            <span>${totalGravada.toFixed(2)}</span>
                          </div>
                          <div className="pt-3 border-t border-slate-200 flex justify-between items-center">
                            <span className="text-lg font-bold text-slate-800">Total a Pagar</span>
                            <span className="text-2xl font-bold text-emerald-600">${totalGravada.toFixed(2)}</span>
                          </div>
                        </div>
                      );
                    }

                    return (
                      <div className="space-y-3">
                        <div className="flex justify-between items-center text-slate-600">
                          <span className="font-medium">Subtotal</span>
                          <span>${resumenVenta.subtotal.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between items-center text-slate-600">
                          <span className="font-medium">IVA (13%)</span>
                          <span>${resumenVenta.impuestos.toFixed(2)}</span>
                        </div>
                        <div className="pt-3 border-t border-slate-200 flex justify-between items-center">
                          <span className="text-lg font-bold text-slate-800">Total Venta</span>
                          <span className="text-2xl font-bold text-emerald-600">${resumenVenta.total.toFixed(2)}</span>
                        </div>
                      </div>
                    );
                  })()}
                </div>

                {/* Botones móviles - Solo en móvil al final del flujo */}
                <div className="md:hidden p-5 border-t border-slate-100 bg-white flex flex-col gap-3 mt-4">
                  <button
                    disabled={submitting}
                    onClick={handleProcesarVenta}
                    className={`w-full py-3.5 rounded-xl flex items-center justify-center gap-3 font-bold shadow-lg shadow-indigo-100 transition-all text-white text-sm uppercase tracking-wide ${submitting
                      ? "bg-indigo-400 cursor-not-allowed shadow-none"
                      : "bg-indigo-600 active:scale-[0.98]"
                      }`}
                  >
                    {submitting && (
                      <span className="inline-block w-5 h-5 border-3 border-white/30 border-t-white rounded-full animate-spin"></span>
                    )}
                    {submitting ? (editMode ? "Actualizando..." : "Procesando...") : (editMode ? "Actualizar Venta" : "Generar Venta")}
                  </button>
                  <button
                    onClick={() => setShowModal(false)}
                    className="w-full py-3.5 rounded-xl border border-slate-300 text-slate-700 font-bold active:scale-[0.98] transition-all text-sm uppercase tracking-wide"
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>

            {/* Footer Desktop - Fijo al fondo del modal */}
            <div className="hidden md:flex p-4 sm:p-6 border-t border-slate-100 bg-slate-50/50 items-center justify-end gap-3 shrink-0">
              <button
                onClick={() => setShowModal(false)}
                className="px-8 py-3 rounded-xl border border-slate-300 text-slate-700 font-bold hover:bg-slate-50 transition-all text-sm uppercase tracking-wide"
              >
                Cancelar
              </button>
              <button
                disabled={submitting}
                onClick={handleProcesarVenta}
                className={`px-10 py-3 rounded-xl flex items-center justify-center gap-3 font-bold shadow-lg shadow-indigo-100 transition-all text-white text-sm uppercase tracking-wide ${submitting
                  ? "bg-indigo-400 cursor-not-allowed shadow-none"
                  : "bg-indigo-600 hover:bg-indigo-700 hover:-translate-y-0.5"
                  }`}
              >
                {submitting && (
                  <span className="inline-block w-5 h-5 border-3 border-white/30 border-t-white rounded-full animate-spin"></span>
                )}
                {submitting ? (editMode ? "Actualizando..." : "Procesando...") : (editMode ? "Actualizar Venta" : "Generar Venta")}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* MODAL ANULACIÓN */}
      {showAnularModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-center z-50 p-4 animate-fade-in">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-xl animate-fade-in-up overflow-hidden">
            <div className="p-6 border-b border-slate-100 flex items-center gap-4 bg-rose-50/30">
              <div className="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 shrink-0 shadow-sm border border-rose-200">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-800">
                  Anular Factura
                </h3>
                <p className="text-sm text-slate-500 mt-1 flex items-center gap-1.5">
                  <span className="font-medium text-slate-600">Código:</span>
                  <span className="font-mono bg-white border border-slate-200 px-1.5 py-0.5 rounded text-slate-700 font-semibold">{facturaSeleccionada?.codGeneration}</span>
                </p>
              </div>
            </div>

            <div className="p-6 space-y-5">
              <div>
                <label className="block mb-2 text-sm font-semibold text-slate-700">Persona que solicita anulación</label>
                <input
                  type="text"
                  value={solicita}
                  onChange={(e) => setSolicita(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-rose-500 focus:border-rose-500 transition-colors bg-slate-50 focus:bg-white"
                  placeholder="Nombre completo"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block mb-2 text-sm font-semibold text-slate-700">Tipo Documento</label>
                  <select
                    value={tipoDocumentoAnulacion}
                    onChange={(e) => setTipoDocumentoAnulacion(e.target.value)}
                    className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-rose-500 focus:border-rose-500 transition-colors bg-white font-medium text-slate-700"
                  >
                    <option value="36">DUI</option>
                    <option value="18">NIT</option>
                  </select>
                </div>
                <div>
                  <label className="block mb-2 text-sm font-semibold text-slate-700">Número</label>
                  <input
                    type="text"
                    value={numeroDocumento}
                    onChange={(e) =>
                      setNumeroDocumento(formatearDocumento(e.target.value, tipoDocumentoAnulacion))
                    }
                    className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-rose-500 focus:border-rose-500 transition-colors bg-slate-50 focus:bg-white"
                    placeholder={tipoDocumentoAnulacion === "18" ? "00000000-0" : "0000-000000-000-0"}
                  />
                </div>
              </div>

              <div>
                <label className="block mb-2 text-sm font-semibold text-slate-700">Motivo de Anulación</label>
                <textarea
                  className="w-full border border-slate-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-rose-500 focus:border-rose-500 transition-colors h-28 resize-none bg-slate-50 focus:bg-white custom-scrollbar"
                  value={motivoAnulacion}
                  onChange={(e) => setMotivoAnulacion(e.target.value)}
                  placeholder="Explique el motivo detalladamente..."
                />
              </div>
            </div>

            <div className="p-6 border-t border-slate-100 bg-slate-50 flex flex-col-reverse sm:flex-row items-center justify-end gap-3">
              <button
                onClick={() => setShowAnularModal(false)}
                className="w-full sm:w-auto px-5 py-2.5 rounded-lg border border-slate-300 text-slate-700 font-medium hover:bg-white focus:ring-2 focus:ring-slate-200 transition-colors"
              >
                Cancelar
              </button>

              <button
                onClick={anularFactura}
                disabled={submitting}
                className={`w-full sm:w-auto px-6 py-2.5 rounded-lg flex items-center justify-center gap-2 font-medium shadow-sm transition-all text-white ${submitting
                  ? "bg-rose-400 cursor-not-allowed shadow-none"
                  : "bg-rose-600 hover:bg-rose-700 hover:shadow-rose-200"
                  }`}
              >
                {submitting && (
                  <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {submitting ? "Anulando..." : "Confirmar Anulación"}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Modal de Productos */}
      {showProductoModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-center z-[60] p-4 sm:p-6 overflow-y-auto w-full">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col my-8 animate-fade-in-up">
            <div className="flex items-center justify-between p-6 border-b border-slate-100 shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">Catálogo de Productos</h3>
              </div>
              <button
                onClick={() => setShowProductoModal(false)}
                className="text-slate-400 hover:text-slate-600 transition-colors bg-slate-50 hover:bg-slate-100 rounded-full p-2"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-6 flex flex-col flex-grow overflow-hidden">
              <div className="relative mb-6">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Buscar producto por nombre, SKU..."
                  value={buscarProducto}
                  onChange={(e) => {
                    setBuscarProducto(e.target.value);
                    setPagePro(1);
                  }}
                  className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors bg-slate-50 focus:bg-white"
                />
              </div>

              <div className="flex-grow overflow-y-auto custom-scrollbar border border-slate-200 rounded-xl bg-white shadow-sm flex flex-col">
                {/* Vista Desktop - Tabla */}
                <div className="hidden md:block">
                  <table className="w-full text-sm text-left">
                    <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200 sticky top-0">
                      <tr>
                        <th className="px-4 py-3 font-semibold">SKU</th>
                        <th className="px-4 py-3 font-semibold">Nombre</th>
                        <th className="px-4 py-3 font-semibold text-right">Precio (con IVA)</th>
                        <th className="px-4 py-3 font-semibold text-center">Existencia</th>
                        <th className="px-4 py-3 font-semibold text-center">Acción</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {productos.map((prod) => {
                        const isAdded = productosSeleccionados.some(p => p.value === prod.id);
                        return (
                          <tr key={prod.id} className="hover:bg-slate-50 transition-colors">
                            <td className="px-4 py-3 text-slate-500 text-xs font-mono">{prod.sku}</td>
                            <td className="px-4 py-3 text-slate-700 font-medium">{prod.name}</td>
                            <td className="px-4 py-3 text-emerald-600 font-semibold text-right">${Number(prod.price).toFixed(2)}</td>
                            <td className="px-4 py-3 text-center">
                              <span className={`px-2 py-1 rounded-full text-xs font-medium ${Number(prod?.ExistenciaProductos?.[0]?.stock) > 10
                                ? 'bg-emerald-50 text-emerald-700'
                                : Number(prod?.ExistenciaProductos?.[0]?.stock) > 0
                                  ? 'bg-amber-50 text-amber-700'
                                  : 'bg-red-50 text-red-700'
                                }`}>
                                {prod?.ExistenciaProductos?.[0]?.stock || 0}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-center">
                              <button
                                className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors w-full flex items-center justify-center gap-1 ${isAdded
                                  ? "bg-emerald-50 text-emerald-600 border border-emerald-200 cursor-default"
                                  : "bg-indigo-50 text-indigo-600 border border-indigo-200 hover:bg-indigo-100 hover:text-indigo-700"
                                  }`}
                                onClick={() => !isAdded && handleAddProducto(prod)}
                                disabled={isAdded}
                              >
                                {isAdded ? (
                                  <>
                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Agregado
                                  </>
                                ) : (
                                  <>
                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                    </svg>
                                    Agregar
                                  </>
                                )}
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      {productos.length === 0 && (
                        <tr>
                          <td colSpan="5" className="px-4 py-8 text-center text-slate-500">
                            No se encontraron productos coincidentes.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Vista Móvil - Cards */}
                <div className="md:hidden divide-y divide-slate-100">
                  {productos.map((prod) => {
                    const isAdded = productosSeleccionados.some(p => p.value === prod.id);
                    const stock = Number(prod?.ExistenciaProductos?.[0]?.stock) || 0;
                    return (
                      <div key={prod.id} className="p-4 space-y-3">
                        <div className="flex justify-between items-start gap-3">
                          <div>
                            <p className="text-[10px] font-mono text-slate-400 mb-0.5">{prod.sku}</p>
                            <h5 className="font-bold text-slate-800 text-sm leading-tight">{prod.name}</h5>
                          </div>
                          <span className={`shrink-0 px-2 py-0.5 rounded-md text-[10px] font-bold ${stock > 10
                            ? "bg-emerald-50 text-emerald-600 border border-emerald-100"
                            : stock > 0
                              ? "bg-amber-50 text-amber-600 border border-amber-100"
                              : "bg-rose-50 text-rose-600 border border-rose-100"
                            }`}>
                            {stock} existencia
                          </span>
                        </div>

                        <div className="flex items-center justify-between gap-4">
                          <span className="text-lg font-bold text-emerald-600">${Number(prod.price).toFixed(2)}</span>
                          <button
                            className={`flex-grow max-w-[140px] px-4 py-2 rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-1.5 ${isAdded
                              ? "bg-emerald-50 text-emerald-600 border border-emerald-100"
                              : "bg-indigo-600 text-white shadow-sm shadow-indigo-100 hover:bg-indigo-700"
                              }`}
                            onClick={() => !isAdded && handleAddProducto(prod)}
                            disabled={isAdded}
                          >
                            {isAdded ? (
                              <>
                                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                Listo
                              </>
                            ) : (
                              <>
                                <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
                                </svg>
                                Agregar
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                  {productos.length === 0 && (
                    <div className="p-8 text-center text-slate-500">
                      No se encontraron productos coincidentes.
                    </div>
                  )}
                </div>
              </div>

              {/* Paginación productos (estilo moderno) */}
              <div className="flex justify-center items-center mt-6 p-2">
                <div className="flex gap-1 bg-white p-1 rounded-lg border border-slate-200">
                  <button
                    disabled={pagePro === 1}
                    onClick={() => setPagePro(pagePro - 1)}
                    className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${pagePro === 1
                      ? "text-slate-400 cursor-not-allowed"
                      : "text-slate-600 hover:bg-slate-100"
                      }`}
                  >
                    Anterior
                  </button>

                  {Array.from({ length: totalPagesPro }, (_, i) => i + 1).map((num) => {
                    // Mostrar solo una ventana de páginas centrada en la actual
                    if (totalPagesPro > 5) {
                      if (num === 1 || num === totalPagesPro || (num >= pagePro - 1 && num <= pagePro + 1)) {
                        return (
                          <button
                            key={num}
                            onClick={() => setPagePro(num)}
                            className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${pagePro === num ? "bg-indigo-50 text-indigo-600" : "text-slate-600 hover:bg-slate-100"
                              }`}
                          >
                            {num}
                          </button>
                        );
                      } else if (num === pagePro - 2 || num === pagePro + 2) {
                        return <span key={num} className="px-2 py-1.5 text-slate-400">...</span>;
                      }
                      return null;
                    }

                    return (
                      <button
                        key={num}
                        onClick={() => setPagePro(num)}
                        className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${pagePro === num ? "bg-indigo-50 text-indigo-600" : "text-slate-600 hover:bg-slate-100"
                          }`}
                      >
                        {num}
                      </button>
                    )
                  })}

                  <button
                    disabled={pagePro === totalPagesPro}
                    onClick={() => setPagePro(pagePro + 1)}
                    className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${pagePro === totalPagesPro
                      ? "text-slate-400 cursor-not-allowed"
                      : "text-slate-600 hover:bg-slate-100"
                      }`}
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div >

            <div className="p-4 sm:p-6 border-t border-slate-100 bg-slate-50 flex items-center justify-end rounded-b-2xl shrink-0">
              <button
                className="px-5 py-2.5 rounded-lg font-medium transition-all text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-indigo-200 shadow-sm"
                onClick={() => setShowProductoModal(false)}
              >
                Cerrar y Volver
              </button>
            </div>
          </div >
        </div >
      )}
      {/* Modal de Error Hacienda */}
      {
        showErrorModal && mhResponse && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-center z-[100] p-4">
            <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up">
              <div className="bg-red-600 p-6 text-white flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="bg-white/20 p-2 rounded-full">
                    <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">Documento Rechazado</h3>
                    <p className="text-red-100 text-sm">Hacienda ha retornado errores en el procesamiento</p>
                  </div>
                </div>
                <button onClick={() => setShowErrorModal(false)} className="text-white/80 hover:text-white transition-colors">
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="p-8 space-y-8">
                {/* Sección Mensaje de Error */}
                <div>
                  <div className="flex items-center gap-2 mb-4 text-red-600">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <h4 className="font-bold uppercase tracking-wider text-sm">Mensaje de Error</h4>
                  </div>
                  <div className="bg-red-50 border-l-4 border-red-500 p-5 rounded-r-xl">
                    <p className="font-mono text-sm text-red-800 break-words leading-relaxed">
                      {mhResponse.descripcionMsg}
                    </p>
                    <div className="mt-3 flex gap-4 text-xs font-semibold text-red-600/70">
                      <span>CÓDIGO: {mhResponse.codigoMsg}</span>
                      <span>CLASE: {mhResponse.clasificaMsg}</span>
                    </div>
                  </div>
                </div>

                {/* Sección Observaciones */}
                {mhResponse.observaciones && mhResponse.observaciones.length > 0 && (
                  <div>
                    <div className="flex items-center gap-2 mb-4 text-amber-600">
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      <h4 className="font-bold uppercase tracking-wider text-sm">Observaciones Técnicas</h4>
                    </div>
                    <div className="bg-amber-50 border-l-4 border-amber-500 p-5 rounded-r-xl">
                      <ul className="space-y-3">
                        {mhResponse.observaciones.map((obs, index) => (
                          <li key={index} className="flex gap-3 text-sm text-amber-900 leading-relaxed">
                            <span className="text-amber-500 mt-1 shrink-0">•</span>
                            <span className="font-medium">{obs}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {/* Información Adicional */}
                <div className="grid grid-cols-2 gap-6 pt-4 border-t border-slate-100">
                  <div className="bg-slate-50 p-4 rounded-xl">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest block mb-1">Código Generación</span>
                    <span className="text-xs font-mono text-slate-600 break-all">{mhResponse.codigoGeneracion}</span>
                  </div>
                  <div className="bg-slate-50 p-4 rounded-xl">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest block mb-1">Fecha Procesamiento</span>
                    <span className="text-xs font-medium text-slate-600">{mhResponse.fhProcesamiento}</span>
                  </div>
                </div>
              </div>

              <div className="bg-slate-50 p-6 border-t border-slate-100 flex justify-end">
                <button
                  onClick={() => setShowErrorModal(false)}
                  className="bg-slate-800 text-white px-8 py-3 rounded-xl font-bold hover:bg-slate-900 transition-all shadow-lg active:scale-95"
                >
                  Entendido
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* Modal de confirmación de eliminación */}
      {
        showEliminarModal && ventaAEliminar && (
          <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-center z-[100] p-4">
            <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
              {/* Cabecera */}
              <div className="bg-red-600 p-5 text-white flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-white/20 p-2 rounded-full">
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold">Confirmar Eliminación</h3>
                    <p className="text-red-100 text-xs">Esta acción no se puede deshacer</p>
                  </div>
                </div>
                <button
                  onClick={() => { setShowEliminarModal(false); setVentaAEliminar(null); }}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Detalle del DTE a eliminar */}
              <div className="p-6 space-y-3">
                <p className="text-sm text-slate-500 mb-4">¿Está seguro de que desea eliminar el siguiente documento?</p>

                <div className="bg-slate-50 rounded-xl p-4 space-y-3 border border-slate-200">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-slate-500 font-medium">Cliente</span>
                    <span className="text-slate-800 font-semibold">{ventaAEliminar.clienteReceptor}</span>
                  </div>
                  <div className="flex justify-between items-center text-sm border-t border-slate-200 pt-3">
                    <span className="text-slate-500 font-medium">Tipo de Documento</span>
                    <span className="text-slate-700">
                      {ventaAEliminar.TipoDocumento?.codigo} | {ventaAEliminar.TipoDocumento?.name}
                    </span>
                  </div>
                  <div className="flex justify-between items-center text-sm border-t border-slate-200 pt-3">
                    <span className="text-slate-500 font-medium">Total</span>
                    <span className="text-emerald-600 font-bold">${Number(ventaAEliminar.totalPagar).toFixed(2)}</span>
                  </div>
                  <div className="flex flex-col gap-1 border-t border-slate-200 pt-3">
                    <span className="text-slate-500 font-medium text-xs">Código de Generación</span>
                    <span className="text-slate-600 font-mono text-xs break-all">{ventaAEliminar.codGeneration}</span>
                  </div>
                </div>
              </div>

              {/* Botones */}
              <div className="bg-slate-50 px-6 py-4 border-t border-slate-100 flex justify-end gap-3">
                <button
                  onClick={() => { setShowEliminarModal(false); setVentaAEliminar(null); }}
                  className="px-5 py-2.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-100 transition-colors text-sm font-medium"
                  disabled={submitting}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleEliminarDTE}
                  disabled={submitting}
                  className="bg-red-600 text-white px-5 py-2.5 rounded-lg hover:bg-red-700 transition-colors text-sm font-bold shadow-sm disabled:opacity-60"
                >
                  {submitting ? "Eliminando..." : "Sí, eliminar"}
                </button>
              </div>
            </div>
          </div>
        )
      }

      {/* ─── Modal Nota de Crédito ──────────────────────────────────── */}
      {
        showNCModal && ventaNC && (() => {
          const jsonDte = ventaNC.jsonDte;
          const resumen = jsonDte?.resumen || {};
          const totalOriginal = Number(resumen.totalPagar ?? resumen.montoTotalOperacion ?? ventaNC.totalPagar ?? 0);
          const subtotalNC = round2(itemsNC.reduce((acc, it) => acc + (Number(it.cantidadEdit) || 0) * (Number(it.precioUniEdit) || 0), 0));

          const isCCF = jsonDte?.identificacion?.tipoDte === "03";
          const ivaNC = isCCF ? round2(subtotalNC * 0.13) : 0;
          const totalNC = round2(subtotalNC + ivaNC);

          const excedido = totalNC > totalOriginal;

          return (
            <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-start z-[100] p-4 overflow-y-auto">
              <div className="bg-white w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden my-8">

                {/* Cabecera */}
                <div className="bg-gradient-to-r from-purple-700 to-purple-500 p-5 text-white flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="bg-white/20 p-2 rounded-full">
                      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold">Nota de Crédito</h3>
                      <p className="text-purple-100 text-xs">Documento relacionado: {jsonDte?.identificacion?.codigoGeneracion}</p>
                    </div>
                  </div>
                  <button onClick={() => setShowNCModal(false)} className="text-white/80 hover:text-white transition-colors">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Info documento original */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 px-6 pt-5 pb-2">
                  <div className="bg-slate-50 rounded-xl p-3 border border-slate-100">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Cliente</span>
                    <span className="text-sm font-semibold text-slate-700 break-words">{jsonDte?.receptor?.nombre}</span>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 border border-slate-100">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Tipo DTE</span>
                    <span className="text-sm font-semibold text-slate-700">{jsonDte?.identificacion?.tipoDte} — {ventaNC.TipoDocumento?.name}</span>
                  </div>
                  <div className="bg-slate-50 rounded-xl p-3 border border-slate-100">
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Fecha emisión</span>
                    <span className="text-sm font-semibold text-slate-700">{jsonDte?.identificacion?.fecEmi}</span>
                  </div>
                  <div className="bg-emerald-50 rounded-xl p-3 border border-emerald-100">
                    <span className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider block mb-1">Total original</span>
                    <span className="text-sm font-bold text-emerald-700">${totalOriginal.toFixed(2)}</span>
                  </div>
                </div>

                {/* Tabla de items editables */}
                <div className="px-6 pb-4">
                  <p className="text-xs text-slate-500 mb-3">Ajusta cantidad y/o precio por ítem. No puede superar el total de la factura original.</p>
                  <div className="overflow-x-auto rounded-xl border border-slate-200">
                    <table className="w-full text-sm">
                      <thead className="bg-slate-50 text-xs text-slate-500 uppercase">
                        <tr>
                          <th className="px-4 py-2 text-left font-semibold">#</th>
                          <th className="px-4 py-2 text-left font-semibold">Descripción</th>
                          <th className="px-4 py-2 text-center font-semibold">Cant.</th>
                          <th className="px-4 py-2 text-center font-semibold">Precio Unit.</th>
                          <th className="px-4 py-2 text-right font-semibold">Subtotal</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {itemsNC.map((it, idx) => {
                          const sub = round2((Number(it.cantidadEdit) || 0) * (Number(it.precioUniEdit) || 0));
                          return (
                            <tr key={idx} className="hover:bg-purple-50/40 transition-colors">
                              <td className="px-4 py-2 text-slate-400 text-xs">{it.numItem}</td>
                              <td className="px-4 py-2 text-slate-700 max-w-[200px]">
                                <span className="block truncate" title={it.descripcion}>{it.descripcion}</span>
                                {it.codigo && <span className="text-[10px] text-slate-400">{it.codigo}</span>}
                              </td>
                              <td className="px-4 py-2 text-center">
                                <input
                                  type="number"
                                  min={0}
                                  max={it.maxCantidad}
                                  step="any"
                                  value={it.cantidadEdit}
                                  onChange={(e) => {
                                    const v = Math.min(Number(e.target.value), it.maxCantidad);
                                    setItemsNC(prev => prev.map((x, i) => i === idx ? { ...x, cantidadEdit: v } : x));
                                  }}
                                  className="w-20 text-center border border-slate-300 rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
                                />
                              </td>
                              <td className="px-4 py-2 text-center">
                                <input
                                  type="number"
                                  min={0}
                                  max={it.maxPrecio}
                                  step="any"
                                  value={it.precioUniEdit}
                                  onChange={(e) => {
                                    const v = Math.min(Number(e.target.value), it.maxPrecio);
                                    setItemsNC(prev => prev.map((x, i) => i === idx ? { ...x, precioUniEdit: v } : x));
                                  }}
                                  className="w-24 text-center border border-slate-300 rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400"
                                />
                              </td>
                              <td className="px-4 py-2 text-right font-semibold text-slate-700">${sub.toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Resumen total NC */}
                  <div className={`mt-4 flex justify-end`}>
                    <div className={`rounded-xl px-5 py-3 border text-right ${excedido ? "bg-red-50 border-red-200" : "bg-purple-50 border-purple-200"}`}>
                      {isCCF && (
                        <div className="mb-2 space-y-1">
                          <div className="flex justify-between gap-8 text-xs">
                            <span className="text-slate-500">Subtotal:</span>
                            <span className="font-semibold text-slate-700">${subtotalNC.toFixed(2)}</span>
                          </div>
                          <div className="flex justify-between gap-8 text-xs">
                            <span className="text-slate-500">IVA (13%):</span>
                            <span className="font-semibold text-slate-700">${ivaNC.toFixed(2)}</span>
                          </div>
                          <div className="border-t border-purple-200 my-1"></div>
                        </div>
                      )}
                      <span className="text-xs text-slate-500 block">Total Nota de Crédito</span>
                      <span className={`text-xl font-bold ${excedido ? "text-red-600" : "text-purple-700"}`}>${totalNC.toFixed(2)}</span>
                      {excedido && (
                        <p className="text-xs text-red-500 mt-1">⚠ Excede el total original (${totalOriginal.toFixed(2)})</p>
                      )}
                    </div>
                  </div>

                  {/* Observaciones */}
                  <div className="mt-4">
                    <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Observaciones</label>
                    <textarea
                      rows={2}
                      value={observacionesNC}
                      onChange={(e) => setObservacionesNC(e.target.value)}
                      placeholder="Motivo de la nota de crédito..."
                      className="w-full border border-slate-300 rounded-xl px-4 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:border-purple-400 resize-none"
                    />
                  </div>
                </div>

                {/* Botones */}
                <div className="bg-slate-50 px-6 py-4 border-t border-slate-100 flex justify-end gap-3">
                  <button
                    onClick={() => setShowNCModal(false)}
                    className="px-5 py-2.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-100 transition-colors text-sm font-medium"
                    disabled={submitting}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleNotaCredito}
                    disabled={submitting || excedido}
                    className="bg-purple-600 text-white px-6 py-2.5 rounded-lg hover:bg-purple-700 transition-colors text-sm font-bold shadow-sm disabled:opacity-60 flex items-center gap-2"
                  >
                    {submitting ? (
                      <>
                        <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                        </svg>
                        Procesando...
                      </>
                    ) : "Generar Nota de Crédito"}
                  </button>
                </div>

              </div>
            </div>
          );
        })()
      }
    </div >
  );
};

export default Ventas;
